var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6478 2.67432L13.1525 8.24117L14.5386 4.9568L20.6478 2.67432Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34474 2.67432L10.7798 8.2939L9.46151 4.9568L3.34474 2.67432Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9511 15.5781L15.9549 18.6365L20.2261 19.8116L21.454 15.6459L17.9511 15.5781Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55374 15.6459L3.77408 19.8116L8.04527 18.6365L6.04903 15.5781L2.55374 15.6459Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80429 10.4105L6.61408 12.2109L10.8551 12.3992L10.7045 7.8418L7.80429 10.4105Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1884 10.4105L13.2506 7.78906L13.1526 12.3992L17.3861 12.2109L16.1884 10.4105Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04541 18.6367L10.5915 17.3938L8.39193 15.6763L8.04541 18.6367Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4012 17.3938L15.9549 18.6367L15.6008 15.6763L13.4012 17.3938Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9546 18.6365L13.4009 17.3936L13.6043 19.0583L13.5817 19.7589L15.9546 18.6365Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04515 18.6365L10.418 19.7589L10.403 19.0583L10.5913 17.3936L8.04515 18.6365Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4556 14.5764L8.33132 13.9511L9.83038 13.2656L10.4556 14.5764Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5368 14.5764L14.162 13.2656L15.6686 13.9511L13.5368 14.5764Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04511 18.6365L8.40669 15.5781L6.04888 15.6459L8.04511 18.6365Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5931 15.5781L15.9547 18.6365L17.9509 15.6459L15.5931 15.5781Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3859 12.2109L13.1524 12.3993L13.5441 14.5763L14.1694 13.2656L15.676 13.9511L17.3859 12.2109Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33133 13.9511L9.83792 13.2656L10.4556 14.5763L10.8549 12.3993L6.61382 12.2109L8.33133 13.9511Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61395 12.2109L8.39173 15.6761L8.33147 13.951L6.61395 12.2109Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6761 13.951L15.6008 15.6761L17.3861 12.2109L15.6761 13.951Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.855 12.3994L10.4557 14.5764L10.9529 17.1452L11.0659 13.7629L10.855 12.3994Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1525 12.3994L12.9491 13.7553L13.0395 17.1452L13.5442 14.5764L13.1525 12.3994Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5442 14.5764L13.0395 17.1451L13.4011 17.3937L15.6007 15.6762L15.676 13.9512L13.5442 14.5764Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33132 13.9512L8.39159 15.6762L10.5912 17.3937L10.9528 17.1451L10.4556 14.5764L8.33132 13.9512Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5819 19.7591L13.6045 19.0586L13.4161 18.8928H10.5762L10.403 19.0586L10.418 19.7591L8.04515 18.6367L8.87377 19.3147L10.5536 20.4823H13.4387L15.1261 19.3147L15.9547 18.6367L13.5819 19.7591Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.401 17.3936L13.0394 17.145H10.9528L10.5912 17.3936L10.4029 19.0584L10.5762 18.8927H13.4161L13.6044 19.0584L13.401 17.3936Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9641 8.60275L21.6044 5.52931L20.6477 2.67432L13.401 8.05285L16.1882 10.4107L20.128 11.5632L21.0018 10.5463L20.6251 10.2751L21.2278 9.72516L20.7607 9.36358L21.3634 8.90407L20.9641 8.60275Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39545 5.52931L3.03576 8.60275L2.62898 8.90407L3.23161 9.36358L2.7721 9.72516L3.37474 10.2751L2.99809 10.5463L3.86438 11.5632L7.80412 10.4107L10.5913 8.05285L3.34461 2.67432L2.39545 5.52931Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1279 11.5632L16.1882 10.4106L17.3859 12.211L15.6006 15.6762L17.9509 15.6461H21.4537L20.1279 11.5632Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80421 10.4106L3.86448 11.5632L2.55374 15.6461H6.04903L8.39178 15.6762L6.61401 12.211L7.80421 10.4106Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1524 12.3991L13.401 8.05259L14.546 4.95654H9.46124L10.5912 8.05259L10.8548 12.3991L10.9452 13.7701L10.9528 17.1449H13.0394L13.0545 13.7701L13.1524 12.3991Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.7747ad2e5a6ece4fa47f92e6d06ea593.svg";
export { ForwardRef as ReactComponent };